"use client"

import { NuisibleFormData } from "@repo/types";
import { UseFormReturn } from "react-hook-form";
import { Alert, AlertDescription } from "../../../components/ui/alert";
import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../../components/ui/form";
import { Input } from "../../../components/ui/input";

interface NuisibleFormFieldsProps {
  form: UseFormReturn<NuisibleFormData>;
  error: string | null;
  isEditing: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
}

export function NuisibleFormFields({
  form,
  error,
  isEditing,
  isSubmitting,
  onCancel,
}: NuisibleFormFieldsProps) {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>
            {isEditing ? "Modifier le nuisible" : "Créer un nouveau nuisible"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          {/* Basic Information */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Informations de base</h3>

            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    Nom du nuisible <span className="text-red-500">*</span>
                  </FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Ex: Processionnaire du pin"
                      {...field}
                      value={field.value || ''}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </CardContent>
      </Card>

      {/* Form Actions */}
      <div className="flex justify-end space-x-4">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Annuler
        </Button>
        <Button
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting
            ? (isEditing ? "Modification..." : "Création...")
            : (isEditing ? "Modifier" : "Créer")
          }
        </Button>
      </div>
    </>
  );
}
